module.exports = __webpack_public_path__ + "static/media/Fresh_Blue_TH2.0bfab8a1.png";